<footer id="footer">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <a href="/#/home" title="WellBrain">
            <img src="/assets/images/WellBrain.png" alt="WellBrain logo" class="footer-logo">
          </a>
        </div>
        <div class="col-md-8">
          <nav class="nav footer-nav">
            <ul class="list list-inline">
              <li class="list-item">
                <a href="/#/terms-and-conditions" title="Terms and conditions">Terms and conditions</a>
              </li>
              <li class="list-item">
                <a href="/#/privacy-policy" title="Privacy Policy">Privacy Policy</a>
              </li>
              <li class="list-item">
                <a href="/#/medical-disclaimer" title="Medical Disclaimer">Medical Disclaimer</a>
              </li>
            </ul>
          </nav>
        </div>
        <div class="col-md-4">
          <nav class="nav social-nav">
            <ul class="list list-inline">
              <li class="list-item">
                <a href="/#/not-yet-enabled" title=""></a>
              </li>
              <li class="list-item">
                <a href="/#/not-yet-enabled" title=""></a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </footer>


// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/footer/footer.component.html